import { FormValues, IFilter } from "../../types";
import { useEffect, useState } from "react";
import { formatDate } from "../../../../../../utils/generalFormat";
import { Button, Container, Label, Col } from "../../../../styles";
import LoadingOverlay from "../../../../../../components/LoadingOverlay";
import { is } from "date-fns/locale";
import { Row } from "antd";
import { Field, Form, Formik } from "formik";
import { toast } from "react-toastify";

export const FormFilter: React.FC<IFilter> = (props: IFilter) => {
  const { getFilters } = props;
  const [isLoading, setIsLoading] = useState(false);
  const todayStr = new Date().toISOString().slice(0, 10);

  const getInitialValue = (): FormValues => {
    const today = new Date();
    const initialDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + 2,
      0,
      0,
      0
    );
    const finalDate = new Date(
      initialDate.getFullYear() + 2,
      initialDate.getMonth(),
      initialDate.getDate(),
      0,
      0,
      0
    );

    return {
      initialDate: formatDate(initialDate),
      finalDate: formatDate(finalDate),
      merchantId: "",
    };
  };

  const handleChangeInitialDate = (
    event: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any) => void
  ) => {
    const { value } = event.target;
    setFieldValue("initialDate", value);
  };

  const handleChangeEndDate = (
    event: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any) => void
  ) => {
    const { value } = event.target;
    setFieldValue("finalDate", value);
  };

  const confirmationValidator = (submit: any) => {
    const isDateFilled = Boolean(submit.initialDate);

    const today = new Date();
    today.setDate(today.getDate() + 1);
    today.setHours(0, 0, 0, 0);

    const submitDate = new Date(submit.initialDate);
    submitDate.setHours(0, 0, 0, 0);

    const isDateTodayOrFuture = isDateFilled && submitDate >= today;

    const isValid = isDateTodayOrFuture;

    if (!isDateTodayOrFuture)
      toast.error("Data de recebimento inicial inválida!!");

    return isValid;
  };

  const getAnticipations = async (submit: any) => {
    const values = getInitialValue();
    if (submit.initialDate == "") {
      submit.initialDate = values.initialDate;
    }

    if (submit.finalDate == "") {
      submit.finalDate = values.finalDate;
    }
    const isValid = confirmationValidator(submit);
    if (isValid) {
      getFilters(submit);
    }

    return submit;
  };

  return (
    <Container style={{ padding: "0px" }}>
      <LoadingOverlay show={isLoading} relative />

      <Row>
        <Label>Filtrar por:</Label>
      </Row>

      <Formik
        initialValues={getInitialValue()}
        onSubmit={async (values: any) => {
          await getAnticipations(values);
        }}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <Row gutter={16}>
              <Col>
                <Field
                  type="text"
                  name="merchantId"
                  placeholder="Cód. Lojista"
                  required
                />
              </Col>

              <Col>
                <input
                  type="date"
                  onChange={(e) => handleChangeInitialDate(e, setFieldValue)}
                  name="rangeStartReceiveDate"
                  placeholder="Data Inicial"
                  step="1"
                />
              </Col>

              <Col>
                <input
                  type="date"
                  onChange={(e) => handleChangeEndDate(e, setFieldValue)}
                  name="rangeEndReceiveDate"
                  placeholder="Data Final"
                  step="1"
                />
              </Col>

              <Col>
                <Button htmlType="submit">Consultar</Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Container>
  );
};
